import { Avatar, Descriptions, Modal, Spin } from 'antd';
import { applicationUrl, capitalize, capitalizeFirstLetter, getInitials, getRandomColor } from '../../../utils';
import useFetch from '../../../custom_hooks/useFetch';
import { useEffect } from 'react';

export default function SettlementAccountInfoModal({ open, handleOkay, selectedItem }) {
    const fetchUrl = selectedItem?.apvId ? `${applicationUrl().url}/api/v1/approval/approved/${selectedItem?.apvRefId}` : null;

    const { isLoading, data } = useFetch(fetchUrl);

    const items = [
        {
            key: '1',
            label: 'Account name',
            children: <span>{capitalizeFirstLetter(selectedItem?.details?.staName)}</span>,
        },
        {
            key: '2',
            label: 'Account number',
            children: (
                <span>
                    {selectedItem?.details?.staAccountNumber} {selectedItem?.details?.staType === 'BANK' ? ' | ' + selectedItem?.details?.staBankName : null}
                </span>
            ),
        },
        {
            key: '3',
            label: 'Account type',
            children: <span>{capitalize(selectedItem?.details?.staType)}</span>,
        },
        {
            key: '4',
            label: 'Account mobile number',
            children: <span>{ selectedItem?.details?.staType === 'BANK' ? '+254' + selectedItem?.details?.staPhoneNumber?.split("-")[1] : 'N/A'}</span>,
        },
    ];

    useEffect(() => {}, [selectedItem]);

    return (
        <>
            <Modal centered className="custom-modal" title={'Review request'} open={open} width={500} footer={false}>
                <div className="flex justify-between items-center bg-[#10101E] w-full h-[4.375rem] px-[2.3125rem]">
                    <span className="heading_4 !text-white">{'Review request'}</span>
                    <button onClick={handleOkay}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M13.4099 12.0002L19.7099 5.71019C19.8982 5.52188 20.004 5.26649 20.004 5.00019C20.004 4.73388 19.8982 4.47849 19.7099 4.29019C19.5216 4.10188 19.2662 3.99609 18.9999 3.99609C18.7336 3.99609 18.4782 4.10188 18.2899 4.29019L11.9999 10.5902L5.70994 4.29019C5.52164 4.10188 5.26624 3.99609 4.99994 3.99609C4.73364 3.99609 4.47824 4.10188 4.28994 4.29019C4.10164 4.47849 3.99585 4.73388 3.99585 5.00019C3.99585 5.26649 4.10164 5.52188 4.28994 5.71019L10.5899 12.0002L4.28994 18.2902C4.19621 18.3831 4.12182 18.4937 4.07105 18.6156C4.02028 18.7375 3.99414 18.8682 3.99414 19.0002C3.99414 19.1322 4.02028 19.2629 4.07105 19.3848C4.12182 19.5066 4.19621 19.6172 4.28994 19.7102C4.3829 19.8039 4.4935 19.8783 4.61536 19.9291C4.73722 19.9798 4.86793 20.006 4.99994 20.006C5.13195 20.006 5.26266 19.9798 5.38452 19.9291C5.50638 19.8783 5.61698 19.8039 5.70994 19.7102L11.9999 13.4102L18.2899 19.7102C18.3829 19.8039 18.4935 19.8783 18.6154 19.9291C18.7372 19.9798 18.8679 20.006 18.9999 20.006C19.132 20.006 19.2627 19.9798 19.3845 19.9291C19.5064 19.8783 19.617 19.8039 19.7099 19.7102C19.8037 19.6172 19.8781 19.5066 19.9288 19.3848C19.9796 19.2629 20.0057 19.1322 20.0057 19.0002C20.0057 18.8682 19.9796 18.7375 19.9288 18.6156C19.8781 18.4937 19.8037 18.3831 19.7099 18.2902L13.4099 12.0002Z"
                                fill="white"
                            />
                        </svg>
                    </button>
                </div>

                <div className="px-[2.94rem] pt-[2.19rem] w-full h-full">
                    <div className="w-full flex flex-col">
                        <div className="grid grid-cols-1 gap-[.94rem]">
                            <span className="label_1 mt-[1.25rem]">{selectedItem?.createdBy} has made the following request to add a new settlement account </span>

                            <div className="w-full mt-[2.25rem]">
                                <Descriptions title={false} items={items} column={1} colon={false} size="small" />
                            </div>

                            {isLoading ? (
                                <Spin className="blu_spin text-left mt-[1.25remrem]" />
                            ) : !isLoading && data.length ? (
                                <>
                                    <span className="label_1 mt-[1.25rem]">The following signitories have already approved </span>
                                    {data?.map((item, index) => {
                                        return (
                                            <div key={index} className="mt-[.5rem]">
                                                <div className="flex items-center gap-[.25rem]">
                                                    <Avatar
                                                        style={{
                                                            backgroundColor: `#${getRandomColor()}`,
                                                        }}
                                                    >
                                                        {getInitials(item?.lastModifiedBy)}
                                                    </Avatar>
                                                    <span>{item?.lastModifiedBy}</span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </>
                            ) : null}
                        </div>

                        <div className="flex items-center justify-center my-[3rem] w-full">
                            <div className="w-[12.4375rem] flex items-center gap-[.5rem]">
                                <button onClick={handleOkay} className="cstm-btn-2" type="button">
                                    Okay
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}
